module.exports = __webpack_public_path__ + "static/media/power-button-off.d6905409.svg";


//////////////////
// WEBPACK FOOTER
// ./src/power-button-off.svg
// module id = 338
// module chunks = 0